import React from 'react';
import { motion } from 'framer-motion';
import { Sun, Thermometer, Clock } from 'lucide-react';
export const Mechanism = () => {
  return <section className="py-16 md:py-24 px-6 bg-charcoal text-cream" data-id="element-47">
      <div className="max-w-4xl mx-auto space-y-12" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-6" data-id="element-49">
          <h2 className="text-3xl md:text-4xl font-serif" data-id="element-50">
            La clave no está en el control, sino en la Sincronización Circadiana
            Progresiva.
          </h2>
          <p className="text-lg text-cream/80 leading-relaxed max-w-3xl mx-auto" data-id="element-51">
            A diferencia de otros métodos, este protocolo ajusta químicamente el
            cerebro de tu bebé usando luz, temperatura y ventanas de vigilia
            específicas. Al alinearse estos tres factores, el cuerpo de tu hijo
            genera melatonina de forma natural en el momento exacto. No lo
            obligas a dormir; preparas su biología para que el sueño sea
            inevitable.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 pt-8" data-id="element-52">
          {[{
          icon: Sun,
          title: 'Luz',
          desc: 'Regulación de melatonina'
        }, {
          icon: Thermometer,
          title: 'Temperatura',
          desc: 'Ambiente óptimo'
        }, {
          icon: Clock,
          title: 'Ventanas',
          desc: 'Tiempos de vigilia'
        }].map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex flex-col items-center text-center space-y-4" data-id="element-53">
              <div className="p-4 bg-terracotta/20 rounded-full text-terracotta" data-id="element-54">
                <item.icon size={32} data-id="element-55" />
              </div>
              <h3 className="font-serif text-xl" data-id="element-56">{item.title}</h3>
              <p className="text-cream/60" data-id="element-57">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};